import LegalShell from "@/pages/LegalShell";

const Datenschutz = () => {
  return (
    <LegalShell eyebrow="Rechtliches" title="Datenschutzerklärung">
      <section data-testid="datenschutz-content">
        <p className="text-white/55">
          Stand: Dezember 2025
        </p>
        <p className="mt-6">
          Der Schutz Ihrer Privatsphäre ist uns wichtig. Diese
          Datenschutzerklärung informiert Sie darüber, welche Daten beim Besuch
          dieser Website (monowood.ch) erhoben werden, wie wir sie verwenden und
          welche Rechte Sie haben — gemäss Schweizer Datenschutzgesetz (DSG)
          und, soweit anwendbar, der EU‑DSGVO.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          1. Verantwortliche Stelle
        </h2>
        <p>
          Nils Abel · E‑Mail:{" "}
          <a
            href="mailto:info@monowood.ch"
            className="text-[#c88a53] hover:text-[#d99c66] transition-colors"
          >
            info@monowood.ch
          </a>
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          2. Erhobene Daten
        </h2>
        <p>
          <strong className="text-white/85">a) Server‑Logs:</strong> Beim Besuch
          dieser Website werden technische Daten (IP‑Adresse, Browser, Zeitpunkt
          des Zugriffs) automatisch durch unseren Hosting‑Provider verarbeitet.
          Diese Daten dienen ausschliesslich der technischen Bereitstellung und
          Sicherheit.
        </p>
        <p className="mt-4">
          <strong className="text-white/85">b) Kontaktformular:</strong> Wenn
          Sie unser Formular nutzen, erheben wir folgende Daten: Name,
          E‑Mail‑Adresse, optional Firma/Organisation, Ihr Anliegen
          (Partnerschaft / Investition) und eine freiwillige Nachricht. Diese
          Daten werden zur Bearbeitung Ihrer Anfrage verwendet und in einer
          Datenbank gespeichert.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          3. Eingesetzte Drittanbieter
        </h2>
        <p>
          <strong className="text-white/85">Resend (E‑Mail‑Versand):</strong>{" "}
          Wir nutzen Resend (Resend Inc., USA) für den automatisierten Versand
          des Pitch Booklets und interner Benachrichtigungen. Hierbei wird Ihre
          E‑Mail‑Adresse an Resend übermittelt.
        </p>
        <p className="mt-4">
          <strong className="text-white/85">Emergent (Hosting):</strong> Die
          Website wird auf der Infrastruktur von Emergent gehostet.
        </p>
        <p className="mt-4">
          <strong className="text-white/85">PostHog (Reichweitenanalyse):</strong>{" "}
          Wir setzen PostHog zur anonymisierten Analyse des Nutzerverhaltens
          ein. PostHog kann hierfür technische Cookies setzen. Es werden keine
          personenbezogenen Profile gebildet.
        </p>
        <p className="mt-4 text-sm text-white/45">
          Da diese Drittanbieter teilweise ausserhalb der Schweiz / des EWR
          sitzen (insb. USA), kann eine Datenübermittlung in Drittländer
          stattfinden. Wir setzen ausschliesslich Anbieter ein, die
          angemessene Schutzmassnahmen treffen.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          4. Speicherdauer
        </h2>
        <p>
          Formulardaten werden so lange gespeichert, wie es zur Bearbeitung
          Ihrer Anfrage erforderlich ist, und anschliessend nach gesetzlichen
          Aufbewahrungsfristen oder auf Ihr Verlangen hin gelöscht.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          5. Ihre Rechte
        </h2>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
          Einschränkung der Verarbeitung sowie auf Datenübertragbarkeit
          bezüglich Ihrer personenbezogenen Daten. Eine formlose Mitteilung an{" "}
          <a
            href="mailto:info@monowood.ch"
            className="text-[#c88a53] hover:text-[#d99c66] transition-colors"
          >
            info@monowood.ch
          </a>{" "}
          genügt.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          6. Sicherheit
        </h2>
        <p>
          Die Übertragung dieser Website erfolgt verschlüsselt über HTTPS.
          Personenbezogene Daten werden gegen unberechtigten Zugriff durch
          technische und organisatorische Massnahmen geschützt.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-lg text-white tracking-tight mb-3">
          7. Änderungen
        </h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie
          stets an aktuelle rechtliche Anforderungen anzupassen. Die jeweils
          aktuelle Version ist auf dieser Seite einsehbar.
        </p>
      </section>
    </LegalShell>
  );
};

export default Datenschutz;
